const doc = [({"da":({"js":({"admin":({"steps":({"updated_element_positions":"Elementposition opdateret", "create":"Opret element"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;